<template>
  <div class="index">
    <van-nav-bar title="退卡退押金" left-text="返回" left-arrow @click-left="onClickLeft"/>
    <div v-if="status == 1 ">
      <van-form @submit="onSubmit" class="form">
        <van-field
          v-model="carForm.carNum"
          name="卡号"
          label="卡号："
          placeholder="卡号"
          disabled
        />
        <div style="margin: 2rem 16px 1rem">
          <van-button round block type="info" native-type="submit">提交</van-button>
        </div>
      </van-form>
    </div>
    <div class="succeed" v-else>
      <van-icon name="checked" size="3rem" color="#4FB640"/>
      <div class="text">押金退款提交成功，款项将在{{infoTime}}内到原路退回</div>
      <van-button style="margin-top:2rem;width:7rem;" round type="info" @click="toPath">返回首页</van-button>
    </div>
  </div>
</template>

<script>

  export default {
    data () {
      return {
        status: 2,
        openId: '',
        carForm: {
          carNum: '',
          money: '',
        },
        infoTime: '24小时'
      }
    },
    created () {
      this.carForm.carNum = this.$route.query.cardNumber
      this.openId = this.$route.query.openId
    },
    mounted () {

    },
    methods: {
      // 提交换卡申请
      onSubmit () {
        this.status = 2
      },
      // 返回首页
      toPath () {
        // this.$router.push({path: '/intelligentLock/portal'})
        location.href = '/#/intelligentLock/portal'
      },
      //   后退
      onClickLeft () {
        location.href = '/#/intelligentLock/portal'
      }

    },
  }
</script>
<style lang="less" scoped>
  .index {
    .form {
      padding-top: 1rem;
      background-color: #fff;

      .van-field {
        font-size: 0.6rem;
      }
    }

    .succeed {
      padding-top: 4rem;

      .text {
        margin-top: 1rem;
        text-align: center;
        font-size: 0.7rem;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/intelligentLock/caroutApplyfor.vue